import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import { FertilizacionService } from "../../../generated/grpc/fertilizacion_pb";
import { grpcFertilizacionDatabase } from "../database/GrpcFertilizacionDatabase";
import { AnalisisLaboratorioResponse } from "../response/AnalisisLaboratorioResponse";
import { fx_createFertilizacionGrpcService } from "./FertilizacionGrpcService";

/** Variante gRPC-Web de `FertilizacionDeleteService` (ver ese archivo): mismo
 *  contrato `IDeleteService`. */
export class FertilizacionDeleteGrpcService
  implements IDeleteService<AnalisisLaboratorioResponse>
{
  async deleteAsync(item: AnalisisLaboratorioResponse): Promise<void> {
    const client = createClient(FertilizacionService, grpcTransportProvider.get());

    try {
      await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcFertilizacionDatabase.deleteOneAsync(item.id);
    fx_createFertilizacionGrpcService(item.fincaId).clearCache();
  }
}
